import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./global-components";
import "./utils";
import "./libs";

// Midone Theme
import "./assets/sass/app.scss";

window.bus = new Vue()

Vue.config.productionTip = false;

var VueCookie = require('vue-cookie');
Vue.use(VueCookie);

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount("#app");